export enum ApplyOnAmazonStatus {
  PENDING = "PENDING",
  PLACEMENT_OK = "PLACEMENT_OK",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export enum ApplyOnAmazonTargetState {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}
